exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_checkboxSkeletonWrapper_agzbjVxZYYHYpYmVEXiMA {\n  display: flex;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.IA_checkboxWrapper_11FWFeYuz4-rqZUR5cdsFL {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_checkboxSkeletonWrapper": "IA_checkboxSkeletonWrapper_agzbjVxZYYHYpYmVEXiMA",
	"IA_checkboxWrapper": "IA_checkboxWrapper_11FWFeYuz4-rqZUR5cdsFL"
};